<template lang="pug">
  .card.mb-0
    .card-header
      .row.w-100
        .form-group.col-12.mb-1
          .d-inline-block.mb-1.mr-3
            DateRangePicker(:value="date" @update="getData")
        .form-group.col-12.mb-1
          SubmitButton(
            icon="fa fa-search"
            :loading="loading"
            :text="$t('ui.search')"
            type="button"
            @click="getList(true)"
            variant="primary"
            size="sm"
          ).mr-2
          jsonToExcel(v-if="voucherRedeemedDetailList.length > 0" mode="VoucherRedeemedDetailList" tbl="tblVoucherRedeemedDetail" :date="date" btnTxt="export_one" type="0" :loading2="loading2").mr-2
          voucherRedeemedDetailExport(v-if="voucherRedeemedDetailList.length > 0" :tbl="voucherRedeemedDetailList" tblId="tblVoucherRedeemedDetail" :totalAmount="grandTotalAmount")
    .card-body
      .row
        .col-12.mb-1
          h2.section-title.mt-0 {{ domainName }}
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-12(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="7%" @click="sortOrder('code')")
                    span(:title="$t('ui.code')") {{ $t('ui.code') }}
                    .float-right
                      i(:class="changeSortKey('code')")
                  th.text-right(width="7%" @click="sortOrder('amount')")
                    span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                    .float-right
                      i(:class="changeSortKey('amount')")
                  th.text-right(width="7%" @click="sortOrder('redeemed_at')")
                    span(:title="$t('ui.redeemed_at')") {{ $t('ui.redeemed_at') }}
                    .float-right
                      i(:class="changeSortKey('redeemed_at')")
              tbody.clusterize-content
                tr(v-if="voucherRedeemedDetailList.length == 0")
                  td(colspan="4").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in voucherRedeemedDetailList")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span(:title="item.code") {{ item.code }}
                  td.text-right
                    span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                  td.text-right
                    span(v-if="item.redeemed_at" :title="$moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.redeemed_at).format('YYYY-MM-DD, HH:mm:ss') }}
                tr(v-if="showTotal")
                  td.text-right(colspan="2")
                    span.d-block {{ $t("ui.sub_total") }}
                    span {{ $t("ui.grand_total") }}
                  td.text-right
                    span.font-weight-bold.d-block(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                    span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                  td

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcelFull.vue";
import voucherRedeemedDetailExport from "@/components/report/voucherRedeemedDetailExportFull.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel,
    voucherRedeemedDetailExport
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    date: {
      type: Object,
      default: ""
    },
    domainName: {
      type: String,
      default: ""
    },
    onSite: {
      type: Boolean,
      default: null
    }
  },
  data: () => ({
    loading: false,
    loading2: false,
    voucherRedeemedDetailList: [],
    voucherRedeemedDetailListFull: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "",
    sortType: "",
    subTotalAmount: 0,
    grandTotalAmount: 0,
    showTotal: false
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {},
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getVoucherRedeemedDetailList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.date.endDate).diff(this.$moment(this.date.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.date.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.date.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getList(true);
    },
    getList(isSearch) {
      if (this.checkDateRange()) {
        this.getVoucherRedeemedDetailList(isSearch);
        // if (this.$helpers.showExportAll(this.date) == true) {
        //   this.getVoucherRedeemedDetailListFull(isSearch);
        // }
      } else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getVoucherRedeemedDetailList: function(isSearch) {
      if (this.checkDateRange()) {
        if (isSearch) this.currentPage = 1;

        let url = ""

        if(this.onSite) url = config.voucherRedeemedOwnDetailUrl();
        else url = config.voucherRedeemedOthersDetailUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id,
          start_date: this.date.startDate,
          end_date: this.date.endDate,
          domain_name: this.domainName,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.voucherRedeemedDetailList = response.data.dt;
                    this.totalRow = response.data.dt.length > 0 ? this.voucherRedeemedDetailList[0]["totalrows"] : 0
                    response.data.dt.forEach(value => {
                      this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
                    });
                    this.grandTotalAmount = response.data.dt[0]["total_amount"];
                    this.showTotal = true
                  }
                  else {
                    this.clearTotal()
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getVoucherRedeemedDetailListFull: function() {
      if (this.checkDateRange()) {
        let url = ""

        if(this.onSite) url = config.voucherRedeemedOwnDetailUrl();
        else url = config.voucherRedeemedOthersDetailUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.id,
          start_date: this.date.startDate,
          end_date: this.date.endDate,
          domain_name: this.domainName,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: -1
        };

        this.loading2 = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading2 = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.voucherRedeemedDetailListFull = response.data.dt;
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function() {
            this.loading2 = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.voucherRedeemedDetailList = []
      this.totalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getVoucherRedeemedDetailList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getVoucherRedeemedDetailList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>